import { signOut } from 'aws-amplify/auth';
import { MAINTENANCE_ERROR_CODE, MAINTENANCE_ERROR_MESSAGE } from '@/constants/constants';
import * as paths from '@/routes/paths';
import { removeSettingState } from '@/state/callbackHelpers';

type ErrorType = {
  code: string;
  message: string;
};

type ErrType = {
  error: ErrorType;
};

export const signOutCallback = (error: ErrorType) => {
  removeSettingState();
  sessionStorage.setItem(MAINTENANCE_ERROR_MESSAGE, error.message);
  window.location.replace(`/#${paths.login}`);
};

export const handleMaintenance = (statusCode: number, responseBody: string) => {
  if (statusCode === 503) {
    const errObj = JSON.parse(responseBody) as ErrType;
    if (errObj?.error?.code === MAINTENANCE_ERROR_CODE) {
      signOut()
        .then(() => {
          signOutCallback(errObj.error);
        })
        .catch(() => {});
    }
    throw new Error(errObj.error.message);
  }
};
